import { useTranslation } from '@hopin-team/provider-translation';
import { Text } from '@hopin-team/ui-text';
import React from 'react';

import { BrandedSpinner, LoadingContainer } from './loading-component-styles';

const Loading = ({ defaultText }: { defaultText?: string }) => {
  const { t } = useTranslation();
  return (
    <LoadingContainer>
      <BrandedSpinner isShowing pattern="jumbo" isPolite />
      <Text mt={1} mb={1}>
        {defaultText ? defaultText : t('common.loading')}
      </Text>
    </LoadingContainer>
  );
};

// eslint-disable-next-line import/no-default-export
export default Loading;
